function checkCsvUploadFileType(file: any) {
  const extension = file.name
    .toLowerCase()
    .split('.')
    .pop();

  if (extension === 'csv' || extension === 'txt') {
    return null;
  } else {
    return 'Only CSV files or plain text files in CSV format are accepted.';
  }
}

export default checkCsvUploadFileType;
